
import React, { Component, Fragment } from 'react'
import logo from '../logo.svg';
import '../App.css';

import TopBanner from '../components/topBanner/TopBanner';
import Services from '../components/services/services';
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import AboutDescription from '../components/AboutDescription/AboutDescription';







export class AboutPage extends Component {
  componentDidMount(){
    window.scroll(0,0);
  }


  render() {
    return (
     <Fragment>
       
             <TopNavigation></TopNavigation>
              <PageTop pageTitle="About Us"></PageTop> 
             <AboutDescription></AboutDescription>
             <Footer></Footer>
             
             
                
        
     </Fragment>
    )
  }
}

export default AboutPage
